import {useEffect} from 'react';
import { HiX } from "react-icons/hi";
import Links from "./componentsrtl/Links";
import './animation.css';
import SidebarCard from "./componentsrtl/SidebarCard";
// import routes from "../../admin_routes.js";

import { useSelector } from 'react-redux';

const Sidebar = ({ open, onClose, routes }) => {
  // const [navBack, setNavBack] = useState("sidebar-Wrapper");
  const theme = useSelector((state) => state.theme);

  useEffect(() =>{
    
  if (theme.isDark) {
    // setNavBack("sidebar-WrapperDark")
    }
    else{
      // setNavBack("sidebar-Wrapper")
    }
  }, [theme.isDark])
  return (
    <div
      className={`sm:none  bg-primaryBlue dark:bg-navy-800  overflow-hidden   duration-175  fixed px-6 m-4 !z-50 flex min-h-[96vh] rounded-xl flex-col  pb-10 shadow-2xl shadow-white/9 transition-all  dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>
      <div className={`mx-[56px] mt-[50px] flex items-start justify-start`}>
        <div className="mt-1 ml-1 h-1 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white">
          {/* FLIO <span className="font-medium">TRAVAL</span> */}
          <img className="mt-[-30px]" src="/fliologo2.png" alt="" width={120} />
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}
      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>
      {/* Free Horizon Card */}
      <div className="flex justify-center">
        <SidebarCard />
      </div>
      {/* Nav item end */}
      <div className="absolute navbar-flight top-[80%] left-0 p-4">
      <div className="   rounded-xl"> <img src="/flightvector.png" alt="" /></div>
      </div>
      <div className="area w-full -z-3 h-full absolute left-0 top-0 " >
            <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
    </div >
    </div>
  );
};

export default Sidebar;
